/**
 * Generated runtime TestId mirror for frontend/src/pages/analytics/SystemGrantsDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const SystemGrantsDetailTestIds = {
  cardTitleActiveGrants: "card-title-active-grants",
  cardTitleEffectiveAccessGrants: "card-title-effective-access-grants",
  cardTitleTotalGrants: "card-title-total-grants",
  cardTitleUniqueIdentities: "card-title-unique-identities",
  colEnforcementObject: "col-enforcement-object",
  colExpand: "col-expand",
  colIdentity: "col-identity",
  colOperation: "col-operation",
  colResource: "col-resource",
  colSourceAccessProfile: "col-source-access-profile",
  colSourceAssignmentExpires: "col-source-assignment-expires",
  colSourceAssignmentStart: "col-source-assignment-start",
  colSourceCreatedAt: "col-source-created-at",
  colStatus: "col-status",
  colValidFrom: "col-valid-from",
  colValidTo: "col-valid-to",
  filterIdentity: "filter-identity",
  filterOperation: "filter-operation",
  linkSystemDetail: "link-system-detail",
  systemGrantsDetailPage: "system-grants-detail-page",
  btnExpandGrant: (grant_accessId: string) => `btn-expand-grant-${grant_accessId}`,
  btnExpandGrantPrefix: () => "btn-expand-grant-" as TestIdPrefix,
  linkAccessProfile: (source_accessProfile_id: string) => `link-access-profile-${source_accessProfile_id}`,
  linkAccessProfilePrefix: () => "link-access-profile-" as TestIdPrefix,
  linkEnforcementObject: (grant_enforcementObject_id: string) => `link-enforcement-object-${grant_enforcementObject_id}`,
  linkEnforcementObjectPrefix: () => "link-enforcement-object-" as TestIdPrefix,
  linkIdentity: (grant_identity_id: string) => `link-identity-${grant_identity_id}`,
  linkIdentityPrefix: () => "link-identity-" as TestIdPrefix,
  linkResource: (grant_resource_id: string) => `link-resource-${grant_resource_id}`,
  linkResourcePrefix: () => "link-resource-" as TestIdPrefix
} as const;
